// extracted by mini-css-extract-plugin
export default {"background":"MainPageWrapper_background__RSpsK"};